<script setup lang="ts">
import {NotificationTemplate} from "@/notification-template/interfaces";

defineProps<{
    template: NotificationTemplate
}>();
</script>

<template>
  <div class="flex flex-col rounded-lg shadow">
    <div class="flex flex-row bg-gray-100 rounded-t-lg py-2 px-4">
      <img src="@/assets/images/customer-app-logo.png" class="w-6 h-6" alt="app logo">
      <span class="text-primary pl-2">Apodis</span>
    </div>
    <div class="p-4">
      <span>{{ template.parsed_content }}</span>
    </div>
  </div>
</template>
